var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    !_vm.$root.isMobile
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _vm.title
                ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
                    _vm.title
                      ? _c("h3", {
                          staticClass: "title",
                          domProps: { innerHTML: _vm._s(_vm.title) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.generatedCtaLink
                      ? _c(
                          "a",
                          {
                            staticClass: "ml-auto my-auto link-arrow",
                            attrs: { href: _vm.generatedCtaLink }
                          },
                          [
                            _vm._v(_vm._s(_vm.cta) + " "),
                            _c("span", {
                              staticClass: "arrow-right",
                              domProps: {
                                innerHTML: _vm._s(_vm.svg("arrow-right"))
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "slide-y-down-transition",
                {
                  staticClass: "speakers-row",
                  attrs: { group: "", tag: "div" }
                },
                _vm._l(_vm.speakers, function(speaker) {
                  return _c("speaker-section-card", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show,
                        expression: "show"
                      }
                    ],
                    key: speaker.ID,
                    staticClass: "speaker-card",
                    class: { "mb-40": _vm.speakers.length > _vm.itemsPerRow },
                    style: { width: "calc(100% / " + _vm.item_count + ")" },
                    attrs: { speaker: speaker, ratio: _vm.ratio }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$root.isMobile,
            expression: "$root.isMobile"
          }
        ],
        staticClass: "row"
      },
      [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", {
            staticClass: "title mb-32",
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _c("div", { ref: "sliderParent", staticClass: "w-100" }, [
            _c(
              "div",
              { ref: "slider", staticClass: "speakers-slider" },
              _vm._l(_vm.speakers, function(speaker) {
                return _c("speaker-section-card", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show,
                      expression: "show"
                    }
                  ],
                  key: speaker.ID,
                  staticClass: "speaker-card mb-40",
                  style: { width: "calc(100% / " + _vm.item_count + ")" },
                  attrs: { speaker: speaker, ratio: _vm.ratio }
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.generatedCtaLink
              ? _c(
                  "a",
                  {
                    staticClass: "ml-auto my-auto link-arrow",
                    attrs: { href: _vm.generatedCtaLink }
                  },
                  [
                    _vm._v(_vm._s(_vm.cta) + " "),
                    _c("span", {
                      staticClass: "arrow-right",
                      domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                    })
                  ]
                )
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }